import { Dashboard } from "domainModels/dashboard"
import { BASE_URL, getDashboardSlug, OgImage } from "lib/utils"

export const getOgImage = (dashboard: Dashboard): OgImage => ({
  title: dashboard.name,
  subTitle: dashboard.owner_name,
  avatar: dashboard.owner_avatar ?? undefined,
  url: `${BASE_URL}/dashboard/${getDashboardSlug(dashboard.id!, dashboard.user_id)}`,
})
